import { vehicleBrand as selector } from "../Selectors/index";

export const vehicleBrandReducer = (state = [], { type, payload }) => {
  switch (type) {
    case selector.GET:
      return payload;

    default:
      return state;
  }
};
